export const chatbotReducer = (state = { loadingChatbot: false, resultchatbot: null, chatbotdata: {}, chatbotmessages: [] }, action) => {
    switch (action.type) {
        case 'CHATBOT_SUCCESS':
            return {
                ...state,
                loadingChatbot: false,
                resultchatbot: action.payload,
                chatbotdata: action.payload,
                chatbotmessages: [
                    ...state.chatbotmessages,
                    {
                        role: 'assistant',
                        content: action.payload.reply || ''
                    }
                ]
            }

        case 'CHATBOT_LOADING':
            return {
                ...state,
                loadingChatbot: true
            }

        case 'CHATBOT_NOT_LOADING':
            return {
                ...state,
                loadingChatbot: false
            }

        case 'CHATBOT_ADD_USER_MESSAGE':
            return {
                ...state,
                chatbotmessages: [
                    ...state.chatbotmessages,
                    action.payload
                ]
            }

        case 'CHATBOT_ADD_BOT_MESSAGE':
            return {
                ...state,
                chatbotmessages: [
                    ...state.chatbotmessages,
                    action.payload
                ]
            }

        case 'CHATBOT_CLEAR_MESSAGES':
            return {
                ...state,
                chatbotmessages: [],
                resultchatbot: null,
                chatbotdata: {}
            }

        default:
            return state
    }
}